/**
 * EcosystemStatsForm: edit form for the `ecosystem-stats` dynamic block.
 *
 * data: { hiddenSections? }
 *
 * One checkbox per section of the live EcosystemAnalytics dashboard, letting
 * an author opt out of any section that's too much for a given landing page.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const SECTIONS = [
    { id: 'stats', label: 'Key stats row' },
    { id: 'heatmap', label: 'Sector connection heatmap' },
    { id: 'charts', label: 'Organizations by sector/region bar charts' },
    { id: 'gaps', label: 'Opportunities for growth (collaboration gaps)' },
];

export default function EcosystemStatsForm({ data, onChange }) {
    const d = data || {};
    const hiddenSections = Array.isArray(d.hiddenSections)
        ? d.hiddenSections
        : [];

    const toggleSection = (sectionId, checked) => {
        const next = checked
            ? hiddenSections.filter((id) => id !== sectionId)
            : [...hiddenSections, sectionId];
        onChange({ ...d, hiddenSections: next });
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label>Visible sections</Form.Label>
            <div className="d-flex flex-column gap-2">
                {SECTIONS.map((section) => (
                    <Form.Check
                        key={section.id}
                        type="checkbox"
                        id={`ecosystem-stats-toggle-${section.id}`}
                        checked={!hiddenSections.includes(section.id)}
                        onChange={(e) =>
                            toggleSection(section.id, e.target.checked)
                        }
                        label={section.label}
                    />
                ))}
            </div>
        </Form.Group>
    );
}

EcosystemStatsForm.propTypes = {
    data: PropTypes.shape({
        hiddenSections: PropTypes.arrayOf(PropTypes.string),
    }),
    onChange: PropTypes.func.isRequired,
};

EcosystemStatsForm.defaultProps = {
    data: {},
};
